var $ = require('jquery');
require('datatables.net');
require('datatables.net-bs4');
require('./bootstrap');
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
fontawesome.library.add(light);

(function($) {
    $('[data-toggle="popover"]').popover()

    $('#claimDescription').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var content = button.data('content'); // Extract info from data-* attributes
        var modal = $(this);
        modal.find('.modal-body').html(content);
    });

    $('#adminNotesModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var claim_id = button.data('claim-id'); // Extract info from data-* attributes
        var admin_notes = button.data('admin-notes');
        var modal = $(this);
        modal.find('textarea#admin_notes').val(admin_notes);
        modal.find('[name="claim_id"]').val(claim_id);
    });
    
    $('#claimStatusModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var claim_id = button.data('claim-id'); // Extract info from data-* attributes
        var status = button.data('status');
        var modal = $(this);
        modal.find('[name="claim_id"]').val(claim_id);
    });

    $('#renewalAuthStatus').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var policy_id = button.data('policy-id'); // Extract info from data-* attributes
        var status = button.data('status');
        var modal = $(this);
        modal.find('[name="policy_id"]').val(policy_id);
    });

    $('#adminNotesModal .js-submit').on('click', function(e) {
        e.preventDefault();

        var admin_notes = $('#adminNotesModal').find('textarea#admin_notes').val();
        var claim_id = $('#adminNotesModal').find('[name="claim_id"]').val();

        if (claim_id) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                method: 'POST',
                url: '/admin/ajax/update_admin_notes',
                data: {
                    admin_notes: admin_notes,
                    claim_id: claim_id
                }
            })
            .done(function (data) {
                $('#adminNotesModal .modal-footer').prepend('<div class="alert alert-success" role="alert">Successfully saved!</div>');

                setTimeout(function() {
                    $('#adminNotesModal .modal-footer .alert').remove();
                }, 2000);

                // Also need to update the note in the data- attribute
                $('button[data-claim-id="' + claim_id + '"').data('admin-notes', admin_notes);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log({jqXHR, textStatus, errorThrown});
            });
        } else {

        }
    });
    
    $('#claimStatusModal .js-submit').on('click', function(e) {
        e.preventDefault();

        var claim_id = $('#claimStatusModal').find('[name="claim_id"]').val();
        var status = $('#claimStatusModal').find('[name="claim_status"]:checked').val();

        if (claim_id) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                method: 'POST',
                url: '/admin/ajax/update_claim_status',
                data: {
                    claim_id: claim_id,
                    status: status,
                }
            })
            .done(function (data) {
                $('#claimStatusModal .modal-footer').prepend('<div class="alert alert-success" role="alert">Successfully changed!</div>');

                setTimeout(function() {
                    $('#claimStatusModal .modal-footer .alert').remove();
                }, 2000);

                // Also need to update the note in the data- attribute
                var status_label = '';

                if (status == 'awaiting_approval') {
                    status_label = 'Awaiting Approval';
                }

                if (status == 'approved') {
                    status_label = 'Approved';
                }

                if (status == 'not_approved') {
                    status_label = 'Not Approved';
                }

                $('tr[data-claim-id="' + claim_id + '"]').find('.status-label').html(status_label);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log({jqXHR, textStatus, errorThrown});
            });
        } else {

        }
    });

    $('#renewalAuthStatus .js-submit').on('click', function (e) {
        e.preventDefault();

        var policy_id = $('#renewalAuthStatus').find('[name="policy_id"]').val();
        var status = $('#renewalAuthStatus').find('[name="renewal_status"]:checked').val();

        if (policy_id) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                method: 'POST',
                url: '/admin/ajax/update_renewal_status',
                data: {
                    policy_id: policy_id,
                    status: status,
                }
            })
                .done(function (data) {
                    $('#renewalAuthStatus .modal-footer').prepend('<div class="alert alert-success" role="alert">Successfully changed!</div>');

                    setTimeout(function () {
                        $('#renewalAuthStatus .modal-footer .alert').remove();
                    }, 2000);

                    // Also need to update the note in the data- attribute
                    var status_label = '';

                    if (status == 'waiting_approval') {
                        status_label = 'Waiting Approval';
                    }

                    if (status == 'not_approved') {
                        status_label = 'Not Approved';
                    }

                    if (status == 'approved') {
                        status_label = 'Approved';
                    }

                    if (status == 'renewed') {
                        status_label = 'Renewed';
                    }

                    $('tr[data-policy-id="' + policy_id + '"]').find('.status-label').html(status_label);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log({ jqXHR, textStatus, errorThrown });
                });
        } else {

        }
    });

    var property_type = '';
    var price = '';

    var enable_pst_saskatchewan = false;
    var enable_pst_manitoba = false;

    $('[name="address"]').change(function() {
        $('[name="address"]').closest('.card').removeClass('active');

        if ($(this).is(':checked')) {
            property_type = $(this).data('property-type');
            $(this).closest('.card').addClass('active');

            var province = $(this).data('province');

            console.log(province);

            $('.verify-promo').attr('data-province', province);

            if (province === 'Saskatchewan') {
                enable_pst_saskatchewan = true;
            } else if (province === 'Manitoba') {
                enable_pst_manitoba = true;
            } else {
                enable_pst_saskatchewan = false;
                enable_pst_manitoba = false;
            }

            updateTotalPrice();
        } else {
            enable_pst_saskatchewan = false;
            enable_pst_manitoba = false;
            updateTotalPrice();
            $(this).closest('.card').removeClass('active');
        }
    });

    var product_price = '';

    $('[name="product"]').change(function() {
        $('[name="product"]').closest('.card').removeClass('active');
        
        if ($(this).is(':checked')) {
            var priced_by_property_type = $(this).data('priced-by-property-type');

            if (priced_by_property_type === 1) {
                if (property_type === 'House') {
                    price = $(this).data('house-price');
                } else {
                    price = $(this).data('condo-price');
                }
            } else {
                price = $(this).data('price');
            }
            $('.verify-promo').attr('data-product', $(this).val());

            var package_name = $(this).data('package-name');

            if ($('table.pricing-details tbody .package-type').length > 0) {
                $('table.pricing-details tbody .package-type td:first').html(package_name);
                $('table.pricing-details tbody .package-type td:last').html('$' + price);
            } else {
                $('table.pricing-details tbody').prepend('<tr class="package-type"><td>' + package_name + '</td><td>$' + price + '</td></tr>');
            }


            updateTotalPrice();

            $(this).closest('.card').addClass('active');
        } else {
            $(this).closest('.card').removeClass('active');

            updateTotalPrice();
        }
    });

    $('[type="checkbox"]').change(function () {
        $(this).parent().toggleClass('active');
    });

    $('[name="appliances[]"]').change(function() {
        var appliance_name = $(this).data('appliance-name');

        if ($(this).is(':checked')) {
            $('table.pricing-details tbody').append('<tr id="' + appliance_name + '"><td><small>Appliance</small> ' + appliance_name + '</td><td>$50.00</td></tr>');
            updateTotalPrice();
        } else {
            $('table.pricing-details tbody tr#' + appliance_name).remove();
            updateTotalPrice();
        }
    });

    $('[name="claim_type"]').change(function () {
        if ($(this).val() === '1') {
            $('.appliance-selection').addClass('active');
            $('.appliance-selection select, .appliance-selection input').prop('required', true);
        } else {
            $('.appliance-selection').removeClass('active');
            $('.appliance-selection select, .appliance-selection input').prop('required', false);
        }
    });

    function updateTotalPrice()
    {
        var total = 0;

        $('table.pricing-details tbody tr td:last-child').each(function(index, element) { 
            var price = $(this).html();
            var number = Number(price.replace(/[^0-9\.-]+/g, ""));
            total += number;
        });

        var promo_amount = $('.promo_amount').html();
        var promo_amount_as_num = Number(promo_amount.replace(/[^0-9\.]+/g, ""));

        // https://stackoverflow.com/a/14428340
        $('table.pricing-details .subtotal').html('$' + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

        var subtotal_minus_promo = (total - promo_amount_as_num);

        var gst = (subtotal_minus_promo * 1.05) - subtotal_minus_promo;
        var pst = 0;

        if (enable_pst_saskatchewan) {
            pst = (subtotal_minus_promo * 1.06) - subtotal_minus_promo;
        }

        if (enable_pst_manitoba) {
            pst = (subtotal_minus_promo * 1.07) - subtotal_minus_promo;
        }

        // Add GST to table
        $('table.pricing-details .gst').html('$' + gst.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $('table.pricing-details .pst').html('$' + pst.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

        var total_with_taxes = subtotal_minus_promo * 1.05;

        if (enable_pst_saskatchewan) {
            var calculate_gst = subtotal_minus_promo * 1.05 - subtotal_minus_promo;
            var calculate_pst = subtotal_minus_promo * 1.06 - subtotal_minus_promo;
            total_with_taxes = subtotal_minus_promo + calculate_gst + calculate_pst;
        }

        if (enable_pst_manitoba) {
            var calculate_gst = subtotal_minus_promo * 1.05 - subtotal_minus_promo;
            var calculate_pst = subtotal_minus_promo * 1.07 - subtotal_minus_promo;
            total_with_taxes = subtotal_minus_promo + calculate_gst + calculate_pst;
        }

        $('table.pricing-details .total').html('$' + total_with_taxes.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
    }

    $('input[name="promocode"]').on('blur', function(e) {

    });


    $('.verify-promo').on('click', function(e) {
        e.preventDefault();
        checkPromoCode($('input[name="promocode"]').val(), $(this).data('product'), $(this).data('province'));
    });

    $('[name="is_realtor"]').change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().parent().parent().find('.realtor-details').addClass('active');

            $('.realtor-details input').prop('required', true);
        } else {
            $(this).parent().parent().parent().find('.realtor-details').removeClass('active');

            $('.realtor-details input').prop('required', false);
        }
    });


    function checkPromoCode(code, product, province)
    {
        $.ajax({
            method: 'POST',
            url: '/promos/verify',
            data: { code: code, product: product, province: province }
        })
        .done(function (data) {
            validatePromoCode(data);
        })
        .fail(function () {
            alert("error");
        });
    }

    function validatePromoCode(data)
    {
        if (data.error) {
            $('input[name="promocode"]').addClass('is-invalid');
            $('.promo-code-verification .valid-feedback').hide();
            $('.promo-code-verification .invalid-feedback').show();
        } else {
            $('input[name="promocode"]').removeClass('is-invalid');
            $('.promo-code-verification .valid-feedback').show();
            $('.promo-code-verification .invalid-feedback').hide();

            $('table tr.promo .promo_amount').html('- $' + data.price);
            $('table tr.promo').show();
            
            updateTotalPrice();
        }
    }
})(jQuery);

(function($) {
    $('#datatables').DataTable();
})(jQuery);

$(document).on('ready', function(e) {
    if ($('[name="claim_type"]').val() === '1') {
        $('.appliance-selection').addClass('active');
        $('.appliance-selection select, .appliance-selection input').prop('required', true);
    }

});




// WEBPACK FOOTER //
// ./resources/assets/js/app.js